import React from 'react';
import { useNavigate } from 'react-router-dom';
import ServerForm from './ServerForm';
import { useLanguage } from '../contexts/LanguageContext';

const AdminServerForm: React.FC = () => {
  const navigate = useNavigate();
  const { t } = useLanguage();

  const handleSuccess = () => {
    navigate('/admin');
  };

  const handleCancel = () => {
    navigate('/admin');
  };

  return (
    <div className="container mx-auto px-4 py-8">
      <div className="mb-6">
        <button
          onClick={() => navigate('/admin')}
          className="text-blue-400 hover:text-blue-300 flex items-center gap-2 transition-colors"
        >
          <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M10 19l-7-7m0 0l7-7m-7 7h18" />
          </svg>
          {t('admin.back_to_dashboard')}
        </button>
      </div>
      <ServerForm onSuccess={handleSuccess} onCancel={handleCancel} />
    </div>
  );
};

export default AdminServerForm;
